import { Editor } from 'slate';
import { deserializeHTMLToDocument } from './deserializeHTMLToDocument.mjs';

function deserializeHTML(inputHtml, {
  editor,
  normalize = true,
  plugins
}) {
  const html = plugins.reduce((acc, plugin) => {
    var _plugin$deserialize$b, _plugin$deserialize, _plugin$deserialize$b2;
    return (_plugin$deserialize$b = (_plugin$deserialize = plugin.deserialize) === null || _plugin$deserialize === void 0 ? void 0 : (_plugin$deserialize$b2 = _plugin$deserialize.before) === null || _plugin$deserialize$b2 === void 0 ? void 0 : _plugin$deserialize$b2.call(_plugin$deserialize, acc)) !== null && _plugin$deserialize$b !== void 0 ? _plugin$deserialize$b : acc;
  }, inputHtml);
  const {
    body
  } = new DOMParser().parseFromString(html, 'text/html');
  let value = deserializeHTMLToDocument({
    plugins,
    element: body
  });
  if (normalize) {
    const newEditor = editor.create(plugins);

    // Set children to the new value
    newEditor.children = value;

    // Force normalization of deserialized value
    Editor.normalize(newEditor, {
      force: true
    });
    value = newEditor.children;
  }
  return value;
}

export { deserializeHTML };
